import { apiConfig } from "core-lib/config/config";
import { postMethod } from "core-lib/utils/apiV2";
import { customToast } from "core-lib/utils/customToast";

export const fetchGenerateLead = async (payload) => {
  const url = `${apiConfig("oem")}/v2/oem/leads/create`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body: payload,
  });

  if (response) {
    if (response?.data?.results) {
      const data = [];
      response?.data?.results?.forEach((item) => {
        if (item?.lead_generated) {
          data.push(item?.lead_id);
        }
      });
      return data;
    }
  }
  if (error) {
    customToast({
      label: error?.message || "Something went wrong",
      variant: "criticalNotPriority",
    });
  }
  return null;
};
